import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ADD_DAYCARE_MEAL_TEXTURE } from '@/modules/API/meal/daycareSettingsHandler.ts'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { useMutation } from '@apollo/client'
import UserInput from '@/components/_custom/UserInput/userInput.tsx'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../meal.module.scss'

interface AddMealTextureDialogProps {
    open: boolean
    handleClose: () => void
    refetch: () => void
    daycareId: number
}

const AddMealTextureDialog: FunctionComponent<AddMealTextureDialogProps> = ({
    open,
    handleClose,
    refetch,
    daycareId
}: AddMealTextureDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [texture, setTexture] = useState<string>('')

    const [addMealTexture] = useMutation(ADD_DAYCARE_MEAL_TEXTURE, {
        variables: {
            daycareId,
            texture
        },
        onCompleted: () => {
            refetch()
            handleClose()
            setTexture('')
            showNotificationSuccess(t('mealTextureAdded'))
        },
        onError: () => {
            handleClose()
            setTexture('')
            showNotificationError(t('mealTextureAddedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('addMealTexture')} />
            <DialogBody className={styles.DialogBody}>
                <UserInput
                    label={t('name')}
                    value={texture}
                    setValue={setTexture}
                    type='text'
                    verify='textLength'
                    textLength={{ min: 1, max: 256 }}
                    className={styles.UserInput}
                />
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type='close' onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type='add'
                        disabled={texture.length < 1 || texture.length > 256}
                        onClick={() => addMealTexture()}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default AddMealTextureDialog
